module.exports = __webpack_public_path__ + "img/last button to hem placket.f9ca2922.png";